import React from 'react'
import {  Label, Input } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { update_bot_details, update_bot_logo } from '../../slices/thunks';

const Bot_image = ({ _profile_image , set_profile_image , set_profile_image_file  }) => {
    const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
    const dispatch = useDispatch()
  return (
    <div className="flex-shrink-0">
    {/* <img src={BotDetails.Bot_Logo} alt="" className="avatar-sm rounded-circle" /> */}
    <div className="text-center bot_profile">
            <div className="profile-user position-relative d-inline-block mx-auto">
                <img src={ _profile_image || BotDetails.Bot_Logo}
                    className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                    alt="user-profile" />
                <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                    <Input 
                    
                    onChange={(e)=>{
                        // set_profile_image(URL.createObjectURL(e.target.files[0]))
                        // set_profile_image_file(e.target.files[0])

                        const file = e.target.files[0];

                        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

                        if (file && allowedTypes.includes(file.type)) {
                            set_profile_image(URL.createObjectURL(file));
                            set_profile_image_file(file);
                            dispatch(update_bot_details({ bot_logo:file , Bot_ID:BotDetails.Bot_ID }))

                        } else {
                            alert('Please upload a valid JPG or PNG file.');
                            e.target.value = null; // Reset the input
                        }
                    }}  
                                                              
                    name='profile_image'  
                    id="profile-img-file-input" 
                    type="file"
                    className="profile-img-file-input" 
                    // accept="image/png  image/jpeg image/jpg"
                    accept=".jpg,.jpeg,.png"
                    />
                    <Label htmlFor="profile-img-file-input"
                        className="profile-photo-edit avatar-xs">
                        <span className="avatar-title rounded-circle bg-light text-body">
                            <i className="ri-camera-fill"></i>
                        </span>
                    </Label>
                </div>
            </div>
        </div>
</div>
  )
}

export default Bot_image